<template>
  <div class="scroll_content">
    <Headbgm />
    <!-- 游戏内容 -->
    <div class="gamecontent">
      <div class="right_item">
        <div class="game_title">Wheel of Fortune Win Big Prizes</div>
        <div class="game_box">
          <div class="img_pop" v-show="showwinbox">
            <img src="@/assets/images/game/turn/img_winner.png" />
            <div class="win_money">{{ windatalist.money }}</div>
          </div>
          <div class="lottery">
            <canvas id="myCanvas" width="600" height="600">
              The current browser version is too low. Please try another browser.
            </canvas>
            <div id="start" class="cursor" @click="startbtn">
              <img src="@/assets/images/game/turn/img_start.png" />
              <span v-show="throttle">Start</span>
              <span v-show="!throttle">Open...</span>
            </div>
          </div>
          <div class="box_shadow" v-show="showloding">
            <van-loading size="100px" color="#d04e18" vertical></van-loading>
          </div>
        </div>
      </div>
    </div>
    <FootGame />
    <!-- 声音 -->
    <div style="display: none">
      <audio id="Staropen">
        <source src="@/assets/music/turn/zpzd.mp3" type="audio/mpeg" />
      </audio>
      <audio id="NoWin">
        <source src="@/assets/music/turn/aao.mp3" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import Headbgm from "@/coms/headbgm.vue";
import FootGame from "@/coms/footgame.vue";
/*global mui,$*/
export default {
  components: {
    Headbgm,
    FootGame,
  },
  data() {
    return {
      showusermesg: false,
      showSetting: false,
      DwheelSurf: null,
      throttle: true,
      list: [],
      showloding: false,
      userwin_money: "",
      userbet_price: "",
      showwinbox: false,
      windatalist: {
        name: "thinks",
        money: 0,
      },
      turn_issue_no: "",
    };
  },
  methods: {
    musicplay() {
      document.getElementById("Staropen").play();
    },
    // 获取转盘配置
    findLuckyTurnConfig() {
      let _this = this;
      this.showloding = true;
      this.axios.get(this.api.api_findConfigs, {
          params: {
            names: "turn_win_money,turn_issue_no",
          },
        })
        .then((res) => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.turn_issue_no = res.data.data.turn_issue_no;
            let turn_win_money = res.data.data.turn_win_money.split("#");
            let lst = turn_win_money.map((item, index) => {
              return {
                id: index + 1,
                name: item == 0 ? "" : item, //奖品名称
                image: this.typeimg(item == 0 ? 2 : 1), //图片
                rank: index + 1, //第几个格子
                percent: "", //中奖概率（所有奖品的概率总和必须是100）
              };
            });
            if (lst.length > 0) {
              this.list = lst;
              this.creatDwheelSurf();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          _this.showloding = false;
          _this.throttle = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    // 开始按钮
    startbtn() {
      let _this = this;
      if (!_this.throttle) return false;
      _this.showloding = true;
      this.axios.post(this.api.api_turnOpen).then((res) => {
          _this.showloding = false;
          if (res.data.code == 0) {
            _this.DwheelSurf.init();
            _this.musicplay();
            _this.throttle = false;
            let rank = res.data.data.rank;
            let money = res.data.data.money;
            let winData = {
              id: rank,
              rank: rank,
              win_result: money,
              image: this.typeimg(1),
            };

            let angel = 360 / _this.list.length;
            let count = 0;
            // 计算奖品角度
            for (const key in _this.list) {
              if (_this.list.hasOwnProperty(key)) {
                if (winData.id == _this.list[key].id) {
                  break;
                }
                count++;
              }
            }
            // 转盘抽奖，
            _this.DwheelSurf.lottery(count * angel + angel / 2, function () {
              _this.throttle = true;
              _this.windatalist = {
                name: winData.name,
                money: winData.win_result,
              };
              
              if (money=='' || money == '₹0') {
                document.getElementById("NoWin").play();
                mui.alert(res.data.data.msg);
                _this.throttle = true;
                return;
              }else{
                _this.showwinbox = true;
              }
              setTimeout(() => {
                _this.showwinbox = false;
              }, 3000);
            });
          } else {
            document.getElementById("NoWin").play();
            mui.alert(res.data.message);
            _this.throttle = true;
          }
        })
        .catch(() => {
          _this.showloding = false;
          _this.throttle = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    //创建转盘
    creatDwheelSurf() {
      // 定义转盘奖品
      this.DwheelSurf = $("#myCanvas").WheelSurf({
        list: this.list, // 奖品列表，(必填)
        outerCircle: {
          color: "#df1e15", // 外圈颜色(可选).
        },
        innerCircle: {
          color: "yellow", // 里圈颜色(可选)
        },
        dots: ["green", "#fbb936"], // 装饰点颜色(可选)
        disk: [
          "wheat",
          "salmon",
          "royalblue",
          "palegreen",
          "wheat",
          "salmon",
          "royalblue",
          "palegreen",
          "wheat",
          "salmon",
          "royalblue",
          "palegreen",
          "wheat",
          "salmon",
          "royalblue",
          "palegreen",
        ], //中心奖盘的颜色，默认7彩(可选)
        title: {
          color: "#5c1e08",
          font: "19px Microsoft YaHei",
        }, // 奖品标题样式(可选)
      });
      // 初始化转盘
      this.DwheelSurf.init();
    },
    typeimg(num) {
      if (num == 1) return "/images/ic_inr.png";
      if (num == 2) return "/images/ic_thanks.png";
    },
  },
  created() {
    this.findLuckyTurnConfig();
  },
};
</script>

<style lang="scss" scoped>
.scroll_content {
  background-image: url(../../assets/images/base/turnbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  .gamecontent {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: left;
    position: relative;
    .right_item {
      width: 100%;
      height: 100%;
      position: relative;
      .game_box {
        width: 600px;
        margin: 72px auto;
      }
      .lottery {
        width: 600px;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      #start {
        width: 200px;
        height: 200px;
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        span {
          font-size: 22px;
          color: #000;
          font-weight: bolder;
          position: absolute;
          top: 53%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
    }
  }
}

.img_pop {
  width: 448px;
  height: 250px;
  position: absolute;
  top: 51%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 99;
  img {
    width: 100%;
    height: 100%;
  }
  .win_money {
    width: 448px;
    height: 50px;
    line-height: 40px;
    text-align: center;
    color: #f63eec;
    position: absolute;
    left: 0;
    top: 370px;
    font-size: 30px;
    font-weight: bold;
  }
}
</style>